import { render, staticRenderFns } from "./ObjectSroJourney.vue?vue&type=template&id=39131281&scoped=true"
import script from "./ObjectSroJourney.vue?vue&type=script&lang=js"
export * from "./ObjectSroJourney.vue?vue&type=script&lang=js"
import style0 from "./ObjectSroJourney.vue?vue&type=style&index=0&id=39131281&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39131281",
  null
  
)

export default component.exports